// extracted by mini-css-extract-plugin
module.exports =  {"counter":"nvgDf7yWMu8hw3SlQDTE","sample":"sSR9pQUCm28zuzxizkCQ","sampleEmpty":"jJlhpSVjxAW86txQPzYg","actions":"CdHqQVpRhPEYQq84JVnG"};